import React from "react";
import {
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { AuthService } from "src/rest/authService";
import LogoutIcon from "src/resources/icons/LogoutIcon";
import { UserAvatarIcon } from "src/resources/icons";
import { GlobalUtils } from "src/utils/globalUtils";
import ConsultantProfileSwitcher from "src/common/ConsultantProfileSwitcher";

export type UserAvatarMenuProps = {
  size?: number;
};

const UserAvatarMenu: React.FC<UserAvatarMenuProps> = ({ size = 55 }) => {
  const navigate = useNavigate();

  const token = GlobalUtils.getToken();
  const role = token ? GlobalUtils.getAppRoleFromToken(token) : "";

  const handleLogout = async (): Promise<void> => {
    try {
      await AuthService.logout();
    } catch {
      // ignore
    }

    try {
      localStorage.removeItem("userRole");
      localStorage.removeItem("authToken");
      const bc = new BroadcastChannel("auth");
      bc.postMessage("logout");
      bc.close();
      sessionStorage.clear();
    } finally {
      navigate("/login", { replace: true, state: { fromApp: true } });
    }
  };

  // Consultants get the full profile-switcher dropdown
  if (role === "CONSULTANT") {
    return <ConsultantProfileSwitcher size={size} />;
  }

  // All other roles get the simple logout menu
  return (
    <HStack>
      <Menu>
        <MenuButton>
          <UserAvatarIcon width={size} height={size} />
        </MenuButton>
        <MenuList minWidth={10}>
          <MenuItem onClick={handleLogout}>
            <HStack alignItems="center">
              <LogoutIcon />
              <Text mb={1}>Logout</Text>
            </HStack>
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
};

export default UserAvatarMenu;
